__turbopack_context__.v({
  "link": "issuersCell-module-scss-module__7VrcEW__link",
  "links": "issuersCell-module-scss-module__7VrcEW__links",
});
